<script setup lang="ts">
import {Coins} from "@lucide/vue";
import {useCreditStore} from "@/stores/credit.store";
import {computed} from "vue";
import {storeToRefs} from "pinia";
import {cn} from "@/lib/utils";
import {pluralize} from "@/core/filters/Pluralize";

const props = defineProps<{
    cost: number
}>();

const {credit, formattedBalance} = storeToRefs(useCreditStore());

const variant = computed(() => {
    return (props.cost > 0 && credit.value && props.cost > credit.value.balance) ? 'destructive' : 'default';
});
</script>

<template>
  <div
    :class="cn(
      'border rounded-lg p-3 flex justify-between gap-4 text-sm leading-tight',
      variant === 'destructive' ? 'bg-red-500/20' : 'bg-muted'
    )"
  >
    <div class="flex items-center gap-2">
      <Coins
        :class="cn(
          'size-4',
          variant === 'destructive' ? 'text-red-500' : 'text-muted-foreground'
        )"
      />
      <p
        :class="cn(
          'font-medium',
          variant === 'destructive' ? 'text-red-700 font-medium' : 'text-foreground'
        )"
      >
        Coût : {{ cost }} {{ pluralize('crédit', cost) }}
      </p>
    </div>
    <div
      v-if="formattedBalance" :class="cn(
        'font-medium',
        variant === 'destructive' ? 'text-red-700 font-medium' : 'text-muted-foreground'
      )"
    >
      <p>Solde : {{ formattedBalance }}</p>
    </div>
  </div>
</template>

<style scoped>

</style>
